export function downloadCsv(filename, rows) {
    const csv = rows.map((r) => Object.values(r).map((v) => escapeCell(v)).join(',')).join('\n')
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    URL.revokeObjectURL(url)
}

function escapeCell(value) {
    if (value == null) return ''
    const str = String(value)
    if (/[",\n]/.test(str)) {
        return '"' + str.replace(/"/g, '""') + '"'
    }
    return str
}

// 업로드용: CSV 문자열을 파싱해 { headers, rows } 반환
// - RFC 4180의 기본 규칙(따옴표/콤마/개행)을 최소 구현
export function parseCsv(text, options = {}) {
    const src = (text ?? '').toString().replace(/^\uFEFF/, '') // BOM 제거
    const delimiter = options.delimiter || detectDelimiter(src) || ','
    const rows = []
    let row = []
    let cur = ''
    let inQuotes = false

    for (let i = 0; i < src.length; i++) {
        const ch = src[i]
        const next = src[i + 1]

        if (inQuotes) {
            if (ch === '"' && next === '"') {
                cur += '"'
                i++
                continue
            }
            if (ch === '"') {
                inQuotes = false
                continue
            }
            cur += ch
            continue
        }

        if (ch === '"') {
            inQuotes = true
            continue
        }
        if (ch === delimiter) {
            row.push(cur)
            cur = ''
            continue
        }
        if (ch === '\r') {
            continue
        }
        if (ch === '\n') {
            row.push(cur)
            rows.push(row)
            row = []
            cur = ''
            continue
        }
        cur += ch
    }
    // last cell
    row.push(cur)
    // trailing empty line 방지
    const hasAny = row.some(c => (c ?? '').toString().trim() !== '')
    if (hasAny) rows.push(row)

    if (rows.length === 0) return { headers: [], rows: [] }
    const headers = (rows[0] || []).map(h => (h ?? '').toString().trim())
    const dataRows = rows.slice(1).map((cells) => {
        const obj = {}
        for (let c = 0; c < headers.length; c++) {
            const key = headers[c] || `col_${c}`
            obj[key] = (cells?.[c] ?? '').toString()
        }
        return obj
    })
    return { headers, rows: dataRows, delimiter }
}

function detectDelimiter(src) {
    const line = firstNonEmptyLine(src)
    if (!line) return ','
    const candidates = [',', ';', '\t']
    let best = ','
    let bestCount = -1
    for (const d of candidates) {
        const cnt = countDelimiterOutsideQuotes(line, d)
        if (cnt > bestCount) {
            best = d
            bestCount = cnt
        }
    }
    return best
}

function firstNonEmptyLine(src) {
    const s = (src ?? '').toString()
    const lines = s.split(/\r?\n/)
    for (const l of lines) {
        if (l != null && String(l).trim() !== '') return String(l)
    }
    return ''
}

function countDelimiterOutsideQuotes(line, delimiter) {
    let inQuotes = false
    let count = 0
    for (let i = 0; i < line.length; i++) {
        const ch = line[i]
        const next = line[i + 1]
        if (inQuotes) {
            if (ch === '"' && next === '"') {
                i++
                continue
            }
            if (ch === '"') inQuotes = false
            continue
        }
        if (ch === '"') {
            inQuotes = true
            continue
        }
        if (ch === delimiter) count++
    }
    return count
}


